module.exports = __webpack_public_path__ + "static/media/matt_meet_matt.8e36a4ec.png";